<template>
  <div class="third" v-loading="loading">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">单位发票抬头配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="updateInvoiceFN_before()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form  style="width:60%;float:left" :model="ruleForm" ref="reasonList" :show-message="false" @validate="validateTwo" label-width="86px">
        <div class="formOne-forms" style="border-right: 1px solid #dcdee2;">
          <template v-for="(item,index) in fliterArr(ruleForm.listData)">
            <div  :key="index" class="forms-one" style="margin-top: 57px;" v-if="!item.delete">
              <div class="one-title">
                <div class="title-left">
                  <span class="left-icon">
                    <i class="el-icon-s-operation"></i>
                  </span>
                  <span class="left-content">单位发票抬头({{NumberToChinese(index+1)}})</span>
                  <span class="left-content " style="color: #ff0000;" @click="addItem(index)"><i class="el-icon-plus"/></span>
                  <span v-if="canDelete" class="left-content" style="color: #ff0000;" @click="deleteItem(index, item)"><i class="el-icon-minus"/></span>
                </div>
              </div>
              <div class="one-list">
                <el-form-item label="名称"
                  :prop="'listData.'+ index + '.name'"
                  :rules="{
                    required: true,
                    message: `请输入名称`,
                    trigger: 'blur'
                  }">
                  <el-input class="list-input" :maxlength="100" v-model="item.name" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="税号"
                  :prop="'listData.'+ index + '.paragraph'"
                  :rules="{
                    required: true,
                    message: `请输入税号`,
                    trigger: 'blur'
                  }">
                  <el-input
                    class="list-input"
                    :maxlength="100"
                    v-model="item.paragraph"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="单位地址"
                  :prop="'listData.'+ index + '.address'"
                  :rules="{
                    required: true,
                    message: `请输入单位地址`,
                    trigger: 'blur'
                  }">
                  <el-input
                    class="list-input"
                    :maxlength="100"
                    v-model="item.address"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="电话号码"
                  :prop="'listData.'+ index + '.tel'"
                  :rules="{
                    required: true,
                    message: `请输入电话号码`,
                    trigger: 'tel'
                  }">
                  <el-input
                    class="list-input"
                    :maxlength="100"
                    placeholder="请输入"
                    @input="
                      value => {
                        value = value.replace(/[^0-9-]+/, '');
                        item.tel = value;
                      }
                    "
                    :value="item.tel"
                  ></el-input>
                </el-form-item>
                <el-form-item label="开户银行"
                  :prop="'listData.'+ index + '.bank'"
                  :rules="{
                    required: true,
                    message: `请输入开户银行`,
                    trigger: 'bank'
                  }">
                  <el-input class="list-input" :maxlength="100" v-model="item.bank" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="银行账户"
                  :prop="'listData.'+ index + '.bank_account'"
                  :rules="{
                    required: true,
                    message: `请输入银行账户`,
                    trigger: 'bank_account'
                  }">
                  <el-input
                    class="list-input"
                    :maxlength="100"
                    @input="
                      value => {
                        value = value.replace(/\D/g, '');
                        item.bank_account = value;
                      }
                    "
                    :value="item.bank_account"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </template>
        </div>
      </el-form>
      <div class="phon-right" style="border-left: 0;">
        <img class="phon-right-img" src="@/assets/dwfptt.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {
  getInvoiceList,
  updateInvoice
} from "@/store/appconfig/UnitInvoiceTitle"; //我的

export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      ruleForm: {
        listData: [
          {
            address: "",
            bank: "",
            bank_account: "",
            id: "",
            name: "",
            paragraph: "",
            school_id: 0,
            tel: "",
            delete: false
          }
        ] //初始数据
      },
      canDelete: true,
      countNum: 1, //用于显示第一个错误
      loading: false
    };
  },
  created() {
    this.getInvoiceListFN();
  },
  methods: {
    // 过滤数组
    fliterArr(arr) {
        let newArr = []
        arr.forEach(element => {
            if (!element.delete) {
                newArr.push(element)
            }
        });
        console.log(this.ruleForm.listData, '222')
        console.log(newArr, '333')
        return newArr
    },
    getFliterAdd() {
        let count = 0
        this.ruleForm.listData.forEach(element => {
            if (!element.delete) {
                count += 1
            }
        });
        if (count <= 1) {
            this.canDelete = false
        } else {
            this.canDelete = true
        }
    },
    addItem(index) {
      let item = {
            address: "",
            bank: "",
            bank_account: "",
            id: "",
            name: "",
            paragraph: "",
            school_id: 0,
            tel: "",
            delete: false
          }
      this.ruleForm.listData.splice(index+1,0,item)
      this.getFliterAdd()
      console.log(this.ruleForm.listData, '333')
    },
    deleteItem(index, item) {
      item.delete = true
      // this.ruleForm.listData.splice(index, 1)
      this.getFliterAdd()
    },
    // 验证
    validateTwo(prop, msgStatus, validateMessage) {
      // console.log(prop, msgStatus, validateMessage)
      if (!msgStatus && !this.countNum) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage)
        }
      }
    },
    //重置
    Reset() {
      this.$refs['reasonList'].resetFields()
      this.getInvoiceListFN();
    },
    SectionToChinese(section){
      let chnNumChar = ["零","一","二","三","四","五","六","七","八","九"]
      let chnUnitSection = ["","万","亿","万亿","亿亿"]
      let chnUnitChar = ["","十","百","千"]
      let strIns = '', chnStr = '';
      let unitPos = 0;
      let zero = true;
      while(section > 0){
        let v = section % 10;
        if(v === 0){
          if(!zero){
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        }else{
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    },
    NumberToChinese(num){
      let chnNumChar = ["零","一","二","三","四","五","六","七","八","九"]
      let chnUnitSection = ["","万","亿","万亿","亿亿"]
      let chnUnitChar = ["","十","百","千"]
      let unitPos = 0;
      let strIns = '', chnStr = '';
      let needZero = false;
      if(num === 0){
        return chnNumChar[0];
      }
      while(num > 0){
        let section = num % 10000;
        if(needZero){
          chnStr = chnNumChar[0] + chnStr;
        }
        strIns = this.SectionToChinese(section);
        strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
        chnStr = strIns + chnStr;
        needZero = (section < 1000) && (section > 0);
        num = Math.floor(num / 10000);
        unitPos++;
      }
      // console.log(chnStr, '22222')
      return chnStr;
    },
    //保存前
    updateInvoiceFN_before() {
      this.countNum = 0;
      this.$refs.reasonList.validate((valid) => {
        if (valid) {
          this.countNum = 1;
          this.updateInvoiceFN();
        } else {
          return false;
        }
      });
    },
    //保存
    updateInvoiceFN() {
      try {
        this.loading = true
        const params = this.ruleForm.listData;
        updateInvoice(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.$message.success("操作成功");
            this.getInvoiceListFN()
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
          this.loading = false
        });
      } catch (err) {
        console.log(err);
        this.loading = false
      }
    },
    //获取数据
    getInvoiceListFN() {
      try {
        this.loading = true
        getInvoiceList().then(res => {
          const data = res.data;
          console.log(data, '数据')
          if (data.status === 1000) {
            if (data.result.length > 0) {
              data.result.forEach(element => {
                element.delete = false
              });
              this.ruleForm.listData = data.result;
              this.getFliterAdd();
            }
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
          this.loading = false
        });
      } catch (err) {
        console.log(err);
        this.loading = false
      }
    },
  }
};
</script>

<style lang="scss">
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  // height:calc(100vh - 102px);
  height: 100%;
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
</style>
